var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12094 3.06813C10.7964 1.64412 13.2036 1.64412 14.8791 3.06813L15.0342 3.08048C17.1177 3.24629 18.7773 4.96174 18.9507 7.1288C20.3498 8.76614 20.3498 11.2341 18.9507 12.8714C18.8373 14.289 18.0879 15.5133 17 16.237V21.0001C17 21.5524 16.5523 22.0001 16 22.0001H15.5C15 22.0001 12 21.0001 12 21.0001C10.8817 21.3729 9 22.0001 8.5 22.0001H8C7.44772 22.0001 7 21.5524 7 21.0001V16.237C5.91208 15.5133 5.16275 14.289 5.04932 12.8714C3.65023 11.2341 3.65023 8.76614 5.04932 7.1288C5.22272 4.96174 6.88229 3.24629 8.96577 3.08048L9.12094 3.06813ZM18 10.0001C18 13.3138 15.3137 16.0001 12 16.0001C8.68629 16.0001 6 13.3138 6 10.0001C6 6.68641 8.68629 4.00012 12 4.00012C15.3137 4.00012 18 6.68641 18 10.0001Z",
    fill: "#E3B40B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.0001C16 12.2093 14.2091 14.0001 12 14.0001C9.79086 14.0001 8 12.2093 8 10.0001C8 7.79098 9.79086 6.00012 12 6.00012C14.2091 6.00012 16 7.79098 16 10.0001Z",
    fill: "#FFE178"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardIcon);
export default __webpack_public_path__ + "static/media/reward_icon.1d79093e899c415afd74152408b7596b.svg";
export { ForwardRef as ReactComponent };